<script>
    import { mapState,mapGetters } from 'vuex';
    import AnimationsMixin from "../../../author/pagesbuilder/mixins/AnimationsMixin";
    import SliderMixin from "../../../author/pagesbuilder/mixins/SliderMixin";
    import FiltersMixin from "../../../author/pagesbuilder/mixins/FiltersMixin";
    import RowsMixin from "../../../author/pagesbuilder/mixins/RowsMixin";

    export default {
        name: "BundleCardsComponent",
        mixins:[
            AnimationsMixin,
            SliderMixin,
            RowsMixin,
            FiltersMixin,
        ],
        data () {
            return {
                componentType: "bundle-cards",
                currentRenderData: {}
            }
        },
        computed : {
            ...mapState('products', [
                'bundles'
            ]),
            ...mapState('user', [
                'userBundleIds'
            ]),
            ...mapGetters('user',[
                'isLoggedIn',
                'isAdmin'
            ]),
            availableCards () {
                return [
                    {
                        cardFilename : 'bundlecard1',
                        forSectionTemplate: "Bundles1",
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/bundlecard1.jpg"
                    },
                    {
                        cardFilename : 'bundlecard2',
                        forSectionTemplate: "Bundles2",
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/bundlecard2.jpg"
                    },
                    {
                        cardFilename : 'bundlecard3',
                        forSectionTemplate: "Bundles3",
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/bundlecard3.jpg"
                    },
                    {
                        cardFilename : 'bundlecard4',
                        forSectionTemplate: "Bundles4",
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/bundlecard4.jpg"
                    },
                    {
                        cardFilename : 'bundlecard5',
                        forSectionTemplate: "Bundles5",
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/bundlecard5.jpg"
                    }
                ]
            },
            getFiltersParams () {
                return {
                    filterLayout: "BundleCardsFilters1",
                    selectedPrimaryFilter : this.getPrimaryFilter,
                    selectedSecondaryFilter : this.getSecondaryFilter,
                    showFilters : this.componentData.showFilters,
                    searchTermValue: this.getPrimaryFilter === 'bySearchTerm' && this.getSecondaryFilter
                        ? this.getSecondaryFilter : ""
                }
            },
            getFiltersConfig () {
                return [
                    {
                        filteringKey: "byAll",
                        filteringFunction: null,
                        filterAvailable: true,
                        label: "All",
                        translatedLabel: this.translations.allBundles
                    },
                    {
                        filteringKey: "byMyBundles",
                        filteringFunction: this.filterBundlesByMyBundles,
                        filterAvailable: this.isLoggedIn,
                        translatedLabel: this.translations.myBundles,
                        label: "My bundles"
                    },
                    {
                        filteringKey: "byCustomList",
                        filteringFunction: this.filterBundlesByCustomList,
                        filterAvailable: true,
                        label: "Custom list",
                        dataSource: this.removePrivate(this.bundles).map( bundle => {
                            return {
                                label: bundle.title,
                                value: bundle.titleId
                            }
                        }),
                    }
                ]
            },
            getActionTriggerComponentsData () {
                return [
                    {
                        label : this.translations.load_more,
                        display: this.currentRenderData.data && (this.currentRenderData.rows * this.currentRenderData.cardsPerRow < this.currentRenderData.data.length),
                        template: "load-more",
                        executableFunction : this.loadMoreClicked
                    }
                ]
            },
            getDefaultCardType () {
                let sectionState = this.findNodeState(this.sectionId);
                let sectionTemplateId = sectionState.sectionTemplateId;
                let cardTypeData = this.availableCards.find(cardData => sectionTemplateId === cardData.forSectionTemplate);

                if (sectionState && cardTypeData) {
                    return cardTypeData.cardFilename;
                }

                return this.availableCards[0] ? this.availableCards[0].cardFilename : "";
            },
            getDefaultDataStructure () {
                return {
                    componentType: this.componentType,
                    componentId: this.componentId,
                    template: 'basicComponentTemplate',
                    cardType: this.getDefaultCardType,
                    styles: null,
                    showFilters : true,
                    primaryFilterKey: "byAll",
                    secondaryFilterKey: "",
                    rows: 1, // this is the currentPage. increments on every click of load more
                    cardsPerRow: 3, // how many cards will load on each page
                    limitAmountOfCards: true, // flag that enables pagination on cards rendering
                    cardsLoadOption: 'load-more',
                    itemVisibilitySettings: null
                }
            },
            contextWrapper () {
                return this.hasContext("context-wrapper") ? this.findNodeState(this.hasContext("context-wrapper")[0].id) : null;
            },
            translations(){
                return {                        
                    course: this.$t('common.course'),
                    courses: this.$t('common.courses'),
                    load_more : this.$t('blog.load_more'),
                    discount: this.$t('bundles.discount'),
                    goToBundle: this.$t('bundles.go_to_bundle'),
                    myBundles: this.$t('bundles.my_bundles'),
                    allBundles: this.$t('bundles.all_bundles'),
                    filter_all: this.$t('starting.filter_all'),
                    filter_my: this.$t('starting.filter_my'),
                    offer: this.$t('bundles.offer'),
                    off: this.$t('bundles.off'),
                    buttonText: this.$t('bundles.buy'),
                };
            }

        },
        methods : {
            editBundlesData (bundlesData) {
                let newData = copyJson(bundlesData);
                newData = this.removePrivate(newData);
                newData = this.applySelectedFilters(newData);
                newData = this.addBundleCardLink(newData);
                newData = this.removeBundledPrivateCourses(newData);
                return newData;
            },
            removeBundledPrivateCourses (bundles) {
                return bundles.map(bundleData => {
                    const bundlePublicCourses = bundleData.courses.filter(course => !!course.product_public);
                    return {
                        ...bundleData,
                        courses: bundlePublicCourses
                    };
                });
            },
            addBundleCardLink (bundles) {
                return bundles.map(bundleData => {
                    return {
                        ...bundleData,
                        cardLink: this.enableHref ? `/bundle/${bundleData.titleId}` : 'javascript:void(0)',
                    }
                });
            },
            applySelectedFilters (bundles) {
                let primaryKey = this.componentData.primaryFilterKey;
                let secondaryKey = this.componentData.secondaryFilterKey;

                this.getFiltersConfig.find( filterData => {
                    if (primaryKey === filterData.filteringKey && filterData.filteringFunction ) {
                        bundles = filterData.filteringFunction.call(null,bundles,secondaryKey);
                        return true;
                    }
                });

                return bundles;
            },
            loadMoreClicked () {},
            handleActionTrigger (componentName) {
                this.getActionTriggerComponentsData.find( data => {
                    if(data.template === componentName && data.executableFunction) {
                        data.executableFunction.call(null);
                        return true;
                    }
                })
            },
            filterBundlesByMyBundles (bundles) {
                return bundles.filter( bundle => {
                    return this.userBundleIds.includes(bundle.titleId);
                });
            },
            filterBundlesByCustomList (bundles,list) {
                return bundles.filter((bundle) => {
                    return list.includes(bundle.titleId);
                });
            },
            removePrivate(bundles) {                
                return bundles.filter((bundle) => {                    
                    return bundle.access !== 'private' ;
                });
            },
            renderComponent () {
                this.renderInProgress = true;
                let bundles = this.editBundlesData(this.bundles);
                let amountOfCards = bundles.length;

                let cardsPerPage = (this.componentData.cardsPerRow > amountOfCards || !this.componentData.limitAmountOfCards) ? amountOfCards : this.componentData.cardsPerRow;

                let renderData = {
                    ...this.componentData,
                    data: bundles,
                    cardsPerRow: cardsPerPage,
                    amountOfCards,
                    translations: this.translations,
                };

                if (renderData.data.length === 0) {
                    return this.renderNoResultsMessage();
                }

                this.currentRenderData = renderData;

                this.renderTemplate(renderData.template, renderData).then(output => {
                    this.componentNode.innerHTML = output;
                    this.addListeners();
                    this.handleSliderCreation(renderData);
                    this.renderingCompleted(renderData);
                });

            },
            renderNoResultsMessage () {
                let renderData = {
                    template: 'nocontentmessage',
                    data: { content: "No results" } // this is when no bundles found for example when someone clicks my bundles button
                };

                let primaryKey = this.componentData.primaryFilterKey;

                if ( !this.isAdmin &&  ( !primaryKey || primaryKey === "byAll")) {
                    // this is when there are no available bundles and not admin
                    renderData.data.content = "There are no available bundles";
                } else if ( this.isAdmin &&  ( !primaryKey || primaryKey === "byAll")) {
                    // this is when there are no available bundles and admin
                    renderData.template = 'nocontentmessage_author_bundlecards'
                    renderData.data.placeholderImageUrl = '/images/placeholders/bundles.jpg';

                    renderData.data.content = 'There are no available bundles yet.';

                    // Hide these for now TODO: enable them again after 1st release and fix link click
                    //renderData.data.link_content = 'Would you like to create one?';
                    //renderData.data.link = '/author/bundles?create=new';
                }

                this.renderTemplate(renderData.template, renderData).then(output => {
                    this.componentNode.innerHTML = output;
                    this.renderingCompleted(renderData);
                });
            },
            addListeners() {

            },
        },
        watch : {
            "myData.cardType": {
                handler (newVal, oldVal){
                    if (newVal !== oldVal && !this.renderInProgress) {
                        this.debouncedRenderComponent();
                    }
                }
            },
            "myData.primaryFilterKey": {
                handler (newVal, oldVal){
                    if (newVal !== oldVal && !this.renderInProgress) {
                        this.debouncedRenderComponent();
                    }

                }
            },
            "myData.cardsPerRow": {
                handler (newVal, oldVal){
                    if (newVal !== oldVal && !this.renderInProgress) {
                        this.debouncedRenderComponent();
                    }

                }
            },
            "myData.rows": {
                handler (newVal, oldVal){
                    if (newVal !== oldVal && !this.renderInProgress) {
                        this.debouncedRenderComponent();
                    }

                }
            },
            "myData.cardsLoadOption": {
                handler (newVal, oldVal){
                    if (newVal !== oldVal) {
                        this.debouncedRenderComponent();
                    }

                }
            },
            "myData.secondaryFilterKey": {
                handler (newVal, oldVal){
                    this.debouncedRenderComponent();
                }
            },
            "bundles" : {
                deep: true,
                handler () {
                    this.debouncedRenderComponent();
                }
            }
        },
    }
</script>
